export const grayOutlinedTextFieldStyle = {
    '& .MuiOutlinedInput-root': {
     borderRadius: '9px', // 👈 Small rounded corners
      backgroundColor: '#F4F5F7',
      '& fieldset': {
        borderColor: '#c4c4c4',
      },
      '&:hover fieldset': {
        borderColor: '#a0a0a0',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#808080',
      },
    },
  };
  